import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Gigs from "@/pages/Gigs";
import Tip from "@/pages/Tip";
import SongRequest from "@/pages/SongRequest";
import Book from "@/pages/Book";
import ClientPlaylist from "@/pages/ClientPlaylist";
import Media from "@/pages/Media";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import UploadInvite from "@/pages/UploadInvite";

const Site = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/gigs" element={<Site><Gigs /></Site>} />
          <Route path="/tip" element={<Site><Tip /></Site>} />
          <Route path="/request" element={<Site><SongRequest /></Site>} />
          <Route path="/book" element={<Site><Book /></Site>} />
          <Route path="/playlist" element={<Site><ClientPlaylist /></Site>} />
          <Route path="/media" element={<Site><Media /></Site>} />
          <Route path="/contact" element={<Site><Contact /></Site>} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/upload/:token" element={<UploadInvite />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
